import React from "react";
import { Box, Typography } from "@mui/material";
import { useIsMobile } from "../../../hooks/responsive";

import { ReactComponent as InexploreTvLogo } from "../../../resources/images/svg/home/podcasts/inexploreTvLogo.svg";
import { ReactComponent as InexploreTvLogo1 } from "../../../resources/images/svg/home/podcasts/inexploreTvLogo1.svg";
import tvImage from "../../../resources/images/png/home/podcasts/tvImage.png";

const TVCard = (props) => {
  const isMobile = useIsMobile();
  return (
    <Box
      sx={{
        background: {
          xs: "linear-gradient(90deg, rgba(33, 99, 158, 0.31) 0%, rgba(108, 52, 144, 0.31) 100%)",
          md: "linear-gradient(90deg, #21639E 0%, #6C3490 100%)",
        },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        mt: isMobile ? 5 : 13,
        p: 5,
      }}
    >
      <img
        src={tvImage}
        alt="tv"
        style={{
          maxWidth: "344px",
          maxHeight: "180px",
          ratio: 344 / 180,
          marginTop: "10px",
          marginBottom: "10px",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          marginLeft: { xs: 0, md: 3 },
        }}
      >
        <Typography
          sx={{
            color: "#F1C555",
            fontSize: "23px",
            fontWeight: "bold",
            textAlign: { xs: "center", md: "left" },
            marginBottom: "10px",
          }}
        >
          Également inclus dans votre abonnement Inexploré Praticiens
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
          }}
        >
          <InexploreTvLogo />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "flex-start" },
              marginLeft: { xs: 0, md: 2 },
            }}
          >
            <InexploreTvLogo1
              style={{
                maxHeight: "60px",
              }}
            />
            <Typography
              sx={{
                color: "white",
                fontSize: "26px",
                fontWeight: "bold",
                marginRight: 3,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Des documentaires pour explorer les plus grands mystères
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TVCard;
